import ScriptApi from "utils/scriptApi";
import ScriptLauncher from "./ScriptLauncher";

class ScriptManager {
  constructor(context) {
    this.context = context;
    this.isOOPScripting = undefined;
    this.scriptLauncher = undefined;
  }

  getScriptLauncher(isOOPScripting) {
    if (!this.scriptLauncher || isOOPScripting !== this.isOOPScripting) {
      this.isOOPScripting = isOOPScripting;
      this.scriptLauncher = isOOPScripting ? new ScriptLauncher(this.context) : new ScriptApi(this.context);
    }
    return this.scriptLauncher;
  }
}

export default ScriptManager;
